import { SiteType } from '../../api/ClientApi';

export const getColorForSiteType = (siteType: SiteType) => {
    switch (siteType) {
        case SiteType.ConstructionSite:
            return 'success';
        case SiteType.Warehouse:
            return 'primary';
        case SiteType.Depot:
            return 'warning';
        default:
            return 'error';
    }
};
